import * as React from 'react';
import s from './Totals.scss';
import get from 'lodash.get';
import { Text } from 'wix-style-react';
import { translate } from 'react-i18next';
import { currencyFormat } from '../../../core';
import { DepositType, } from '@wix/ambassador-wix-quotes-web/types';
import { getCurrencyByKey } from '@wix/locale-dataset-javascript';
var AmountToPay = function (props) {
    var label = props.label, value = props.value, dataHookPrefix = props.dataHookPrefix;
    return (React.createElement("div", { className: s.balance },
        React.createElement(Text, { dataHook: "".concat(dataHookPrefix, "-label") }, label),
        React.createElement(Text, { className: s.balanceValue, weight: "bold", size: "medium", dataHook: "".concat(dataHookPrefix, "-text") }, value)));
};
var Totals = function (_a) {
    var _b;
    var t = _a.t, invoice = _a.invoice, _c = _a.invoiceDepositUoUEnabled, invoiceDepositUoUEnabled = _c === void 0 ? true : _c, showTaxBreakdown = _a.showTaxBreakdown, taxSettingsEnabled = _a.taxSettingsEnabled;
    var currency = invoice.currencyCode;
    var fraction = getCurrencyByKey(currency).fraction;
    var subtotal = get(invoice.totals, ['subtotal', 'serializedValue'], 0);
    var discountAmount = get(invoice.totals, ['discountAmount', 'serializedValue'], 0);
    var total = get(invoice.totals, ['total', 'serializedValue'], 0);
    var fees = get(invoice.totals, 'fees');
    var discountRate = get(invoice.discount, ['percentage', 'serializedValue']);
    var depositRate = Number(get(invoice.deposit, 'percentage', 0));
    var depositAmount = Number(get(invoice.deposit, 'flatAmount', 0));
    var depositType = get(invoice.deposit, 'type');
    var taxes = (_b = get(invoice.taxes, 'taxes')) !== null && _b !== void 0 ? _b : [];
    var paidAmount = get(invoice.dynamicTotals, ['paidAmount', 'serializedValue'], 0);
    var balance = get(invoice.dynamicTotals, ['balance', 'serializedValue'], 0);
    var format = currencyFormat({
        locale: invoice.locale && invoice.locale.language,
        currency: currency,
    });
    function hasDeposit() {
        return (invoiceDepositUoUEnabled &&
            !!depositAmount &&
            depositAmount - paidAmount > 0);
    }
    return (React.createElement("div", { className: s.totals },
        React.createElement("div", { className: s.item, style: { marginBottom: '-5px' } },
            React.createElement(Text, { weight: "thin", dataHook: "subtotal-label" }, taxSettingsEnabled
                ? t('quote.form.net-total')
                : t('quote.form.sub_total')),
            React.createElement("div", { className: s.totalValue },
                React.createElement(Text, { weight: "thin", dataHook: "subtotal-text" }, format(subtotal)))),
        !!fees &&
            fees
                .filter(function (_a) {
                var price = _a.price.serializedValue;
                return !!price;
            })
                .map(function (_a) {
                var name = _a.name, price = _a.price.serializedValue;
                return price !== 0 && (React.createElement("div", { key: "fee-".concat(name), className: s.item },
                    React.createElement(Text, { weight: "thin", dataHook: "fee-".concat(name, "-name") }, name),
                    React.createElement("div", { className: s.totalValue },
                        React.createElement(Text, { weight: "thin", dataHook: "fee-".concat(name, "-value") }, format(price)))));
            }),
        !!discountRate && (React.createElement("div", { className: s.item },
            React.createElement(Text, { weight: "thin", dataHook: "discount-label" }, "".concat(t('quote.form.discount'), " (").concat(discountRate, "%)")),
            React.createElement("div", { className: s.totalValue },
                React.createElement(Text, { weight: "thin", dataHook: "discount-text" }, format(discountAmount))))),
        !showTaxBreakdown && (React.createElement("div", { className: s.item },
            React.createElement(Text, { weight: "thin", dataHook: "taxes" }, t('price-quote.view.totals.taxes')),
            React.createElement("div", { className: s.totalValue },
                React.createElement(Text, { dataHook: "tax-totals", weight: "thin" }, format(taxes.reduce(function (sum, tax) { var _a; return sum + ((_a = tax.taxed.serializedValue) !== null && _a !== void 0 ? _a : 0); }, 0)))))),
        !!taxes &&
            showTaxBreakdown &&
            taxes
                .filter(function (_a) {
                var taxed = _a.taxed.serializedValue;
                return taxed !== undefined;
            })
                .map(function (_a) {
                var taxed = _a.taxed.serializedValue, taxRate = _a.rate.serializedValue, name = _a.name;
                return (React.createElement("div", { key: "".concat(name, "-").concat(taxRate), className: s.item },
                    React.createElement(Text, { weight: "thin", dataHook: "tax-".concat(name, "-").concat(taxRate, "-name") }, t('price-quote.view.totals.tax-rate', {
                        name: name,
                        rate: taxRate,
                    })),
                    React.createElement("div", { className: s.totalValue },
                        React.createElement(Text, { dataHook: "tax-".concat(name, "-").concat(taxRate, "-taxed"), weight: "thin" }, format(taxed)))));
            }),
        React.createElement("hr", { className: s.divider }),
        React.createElement("div", { className: s.item },
            React.createElement(Text, { dataHook: "total-label", weight: "thin" }, t('invoice-view:quoteview.uou_total')),
            React.createElement("div", { className: s.totalValue },
                React.createElement(Text, { dataHook: "total-text", weight: "thin" }, format(total)))),
        hasDeposit() && (React.createElement("div", { className: s.item },
            React.createElement(Text, { weight: "thin", dataHook: "deposit-label" }, depositType === DepositType.PERCENTAGE
                ? "".concat(t('quote.form.deposit'), " (").concat(Number((depositRate * 100).toFixed(fraction)), "%)")
                : "".concat(t('quote.form.deposit'))),
            React.createElement("div", { className: s.totalValue },
                React.createElement(Text, { weight: "thin", dataHook: "deposit-text" }, format(depositAmount))))),
        React.createElement("div", { className: s.item },
            React.createElement(Text, { dataHook: "amount-paid-label", weight: "thin" }, t('invoice-view:quote.form.amount_paid')),
            React.createElement("div", { className: s.totalValue },
                React.createElement(Text, { dataHook: "amount-paid-total-text", weight: "thin" }, format(paidAmount)))),
        hasDeposit() ? (React.createElement(AmountToPay, { label: t('invoice-view:quote.form.deposit-due'), value: format(depositAmount - paidAmount), dataHookPrefix: "deposit-due" })) : (React.createElement(AmountToPay, { label: t('invoice-view:quote.form.balance'), value: format(balance), dataHookPrefix: "balance" }))));
};
export default translate(['invoice-view', 'locale-data'])(Totals);
//# sourceMappingURL=Totals.js.map